import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    videoContainer: {
        // default on mobile the image is full width and positioned above or below the content
        width: '100%',
        position: 'relative',
        // Use aspect-ratio instead of padding-top for better stability
        aspectRatio: '1/1', // Square on mobile
        minHeight: '200px', // Fallback for older browsers
        [theme.breakpoints.up('sm')]: {
            // default on desktop is for image to be 50% wide unless fullImage
            width: '50%',
            aspectRatio: 'auto', // Let content determine height on desktop
            minHeight: '300px', // Ensure minimum height on desktop
        },
    },
    squareVideoContainer: {
        aspectRatio: '1/1',
        position: 'relative',
        overflow: 'hidden',
        // Light containment without forced positioning
        contain: 'layout style',
        [theme.breakpoints.up('sm')]: {
            aspectRatio: 'auto',
            minHeight: '300px',
        },
    },
    portraitVideoContainer: {
        // On mobile, keep 1/1 aspect ratio so the container has defined height
        // (absolute-positioned children don't contribute height)
        overflow: 'hidden',
        contain: 'layout style',
        [theme.breakpoints.up('sm')]: {
            aspectRatio: 'unset',
        },
    },
}));
export default useStyles;
